<template>
  <div
    v-show="!loading"
    id="login"
  >
    <login-alert />
    <sidepage
      :show-quotes="false"
    />
    <div id="login-contents">
      <div
        id="login-body"
        class="body"
      >
        <div
          id="login-sign-up"
        >
          <div class="content-block">
            <img
              class="logo"
              src="@/assets/images/tango-logo.svg"
              alt="Tango"
            >
          </div>
          <div
            v-if="showFindLoginMethod"
            class="login-sign-up-content-block"
          >
            <span
              id="login-sign-up-text"
              class="login-sign-up-text"
            >
              {{ $t('login.form.noAccount') }}
            </span>
            <tc-v-btn
              id="login-sign-up-btn"
              color="primary"
              text
              :to="rgSignupLink"
              target="_blank"
            >
              {{ $t('login.form.signUpButton') }}
            </tc-v-btn>
          </div>
        </div>
        <find-login-method
          v-if="showFindLoginMethod"
          @update-login-method-user-name="setLoginMethodUserName"
          @update-login-method-type="setLoginMethodType"
          @show-all-login-methods="setShowAllLoginMethods"
        />
        <password-login
          v-if="showPasswordLoginForm"
          :default-user-name="defaultUserName"
        />
        <hr
          v-if="showAllLoginMethods"
          class="or-log-in-via"
        >
        <div class="alternate-logins">
          <social-login
            v-if="showGoogleLoginForm"
            id="google-login"
            class="alternate-login"
            :provider="'google'"
            sign-with-provideri18n-key="login.form.buttonSocial"
          />
          <social-login
            v-if="showAuth0LoginForm"
            id="auth0-login"
            class="alternate-login"
            :provider="'auth0'"
            sign-with-provideri18n-key="login.form.buttonSocial"
          />
          <sso-login
            v-if="showSSOLoginForm"
            class="alternate-login"
            :default-user-name="loginMethodUserName"
            :sso-button="showSSOButton"
          />
          <tc-v-btn
            v-if="showSSOButton"
            id="SSO-login-button"
            class="btn-secondary w-100"
            @click="$router.push({ name: 'SSOLogin' })"
          >
            {{ $t('login.form.buttonSSO') }}
          </tc-v-btn>
        </div>
        <div class="all-login-methods">
          <tc-v-btn
            v-if="showAllLoginMethodsButton"
            id="show-all-login-methods-btn"
            class="btn-secondary"
            @click="setShowAllLoginMethods"
          >
            {{ $t('login.showAllLoginMethods') }}
          </tc-v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SocialLogin from './SocialLogin'
import AuthenticationProvider from '@/components/shared/security/authentication-provider'
import { APP_GET_LOADING } from '@/store/get-types'
import SidePage from '@/components/shared/SidePage'
import FindLoginMethod from './FindLoginMethod'
import PasswordLogin from './PasswordLogin'
import SSOLogin from './SSOLogin'
import LoginAlert from './login-alert/LoginAlert'
import { RG_LOGIN_METHOD } from '../shared/constants/localstorage.constants'
import { LoginMethodTypes } from './enum/LoginMethodType'
import { RG_AUTH0_LOGIN } from '@/components/shared/split/split-constants'
import { SIGNUP_ROUTE } from '@/router/route-name-constants'

export default {
  name: 'Login',
  components: {
    sidepage: SidePage,
    'social-login': SocialLogin,
    FindLoginMethod,
    PasswordLogin,
    LoginAlert,
    'sso-login': SSOLogin
  },
  data () {
    return {
      LoginMethodTypes: LoginMethodTypes,
      showAllLoginMethods: false,
      loginMethodUserName: null,
      loginMethodType: null
    }
  },
  computed: {
    loading () {
      return this.$store.getters[APP_GET_LOADING]
    },
    rgSignupLink () {
      return { name: SIGNUP_ROUTE }
    },
    showFindLoginMethod () {
      return !this.showAllLoginMethods && !this.loginMethodType
    },
    showSSOButton () {
      return this.showAllLoginMethods
    },
    showSSOLoginForm () {
      return this.loginMethodType === LoginMethodTypes.SAML && !this.showAllLoginMethods
    },
    showAllLoginMethodsButton () {
      return !this.showFindLoginMethod && !this.showAllLoginMethods
    },
    showGoogleLoginForm () {
      return this.loginMethodType === LoginMethodTypes.GOOGLE || this.showAllLoginMethods
    },
    showAuth0LoginForm () {
      return (this.loginMethodType === LoginMethodTypes.AUTH0 || this.showAllLoginMethods) && this.isAuth0LoginSplitEnabled
    },
    showPasswordLoginForm () {
      return this.loginMethodType === LoginMethodTypes.PASSWORD || this.showAllLoginMethods
    },
    defaultUserName () {
      const useLoginMethodUserName = this.showAllLoginMethods
      return useLoginMethodUserName ? '' : this.loginMethodUserName
    },
    isAuth0LoginSplitEnabled () {
      return this.$isSplitEnabled(RG_AUTH0_LOGIN)
    }
  },
  mounted () {
    AuthenticationProvider.clearTokens()

    if (this.$route.query.ftl) {
      this.$toast(
        this.$t('login.messages.info.hasUser'),
        'info'
      )
    }

    this.loginMethodType = localStorage.getItem(RG_LOGIN_METHOD)
  },
  methods: {
    setShowAllLoginMethods () {
      this.showAllLoginMethods = true
    },
    setLoginMethodUserName (loginMethodUserName) {
      this.loginMethodUserName = loginMethodUserName
    },
    setLoginMethodType (loginMethod) {
      this.loginMethodType = loginMethod
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Login';

  .btn-secondary {
    width: 100%;
  }
  .all-login-methods {
    text-align: center;
  }

  .alternate-logins .alternate-login {
    margin-top: 12px;
    margin-bottom: 24px;
  }
</style>
